import React, { useEffect, useState } from 'react';
import { CheckCircle2Icon } from 'lucide-react';
const NAMES = ['Ana', 'Sofía', 'Camila', 'Isabella', 'Mariana', 'Gabriela', 'Paula', 'Andrea', 'Daniela', 'Laura', 'Carmen', 'Pilar', 'Rosa', 'Elena', 'Claudia'];
const CITIES = ['Buenos Aires, Argentina', 'Bogotá, Colombia', 'Lima, Perú', 'Santiago, Chile', 'Madrid, España', 'Barcelona, España', 'Montevideo, Uruguay', 'Quito, Ecuador', 'Medellín, Colombia', 'Córdoba, Argentina', 'Guadalajara, México', 'CDMX, México', 'Rosario, Argentina', 'Sevilla, España', 'Caracas, Venezuela'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [buyerInfo, setBuyerInfo] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      setBuyerInfo({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    // Initial delay before first popup
    const initialTimer = setTimeout(showPopup, 5000);
    // Setup recurring interval (random between 15-30 seconds)
    const intervalId = setInterval(() => {
      if (!isVisible) {
        showPopup();
      }
    }, Math.floor(Math.random() * 15000) + 15000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(intervalId);
    };
  }, [isVisible]);
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-50 animate-slide-up" data-id="element-151">
      <div className="bg-white rounded-lg shadow-xl border border-brand-green/10 p-4 flex items-center gap-3 max-w-sm" data-id="element-152">
        <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-153">
          <CheckCircle2Icon className="w-5 h-5 text-green-600" data-id="element-154" />
        </div>
        <div data-id="element-155">
          <p className="text-sm text-gray-800" data-id="element-156">
            <span className="font-bold" data-id="element-157">{buyerInfo.name}</span> de{' '}
            {buyerInfo.city}
          </p>
          <p className="text-xs text-gray-500" data-id="element-158">
            acaba de comprar este producto.
          </p>
        </div>
      </div>
    </div>;
}